(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    (function(){
 const initialized=new WeakSet();
 function init(){
  const root=document.querySelector('.ba-mask-gallery');
  if(!root||initialized.has(root))return;
  initialized.add(root);
  root.dataset.ready='true';
  const track=root.querySelector('.ba-mask-pictures'),pictures=Array.from(track.children),thumbs=Array.from(root.querySelectorAll('.ba-mask-thumb')),more=root.querySelector('.ba-mask-more'),dialog=root.querySelector('dialog'),zoom=root.querySelector('.ba-mask-zoom-image'),count=root.querySelector('.ba-mask-count');
  let selected=0,returnFocus=null;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('ba:gallery:variant',event=>{
    if(String(event.detail.productId)!==root.dataset.productId)return;
    const index=pictures.findIndex(picture=>picture.dataset.imageId===String(event.detail.imageId));
    if(index<0)return;
    if(window.matchMedia('(max-width:798px)').matches){track.scrollTo({left:pictures[index].offsetLeft-track.offsetLeft,behavior:'instant'});mark(index);}
    else{const source=pictures[index].querySelector('img'),hero=pictures[0].querySelector('img');hero.src=source.currentSrc||source.src;hero.srcset=source.srcset;hero.alt=source.alt;pictures[0].dataset.full=pictures[index].dataset.full;}
  });
  function mark(index){thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===index)));}
  thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>{track.scrollTo({left:pictures[i].offsetLeft-track.offsetLeft,behavior:reduced?'instant':'smooth'});mark(i);}));
  track.addEventListener('scroll',()=>{if(window.matchMedia('(max-width:798px)').matches){const i=Math.max(0,Math.min(pictures.length-1,Math.round(track.scrollLeft/track.clientWidth)));mark(i);}}, {passive:true});
  if(more)more.addEventListener('click',()=>{const expanded=more.getAttribute('aria-expanded')!=='true';track.classList.toggle('is-expanded',expanded);more.setAttribute('aria-expanded',String(expanded));more.textContent=expanded?more.dataset.less:more.dataset.more;});
  function show(index){selected=(index+pictures.length)%pictures.length;zoom.src=pictures[selected].dataset.full;zoom.alt=pictures[selected].querySelector('img').alt;count.textContent=(selected+1)+' / '+pictures.length;}
  pictures.forEach((picture,i)=>picture.addEventListener('click',()=>{returnFocus=picture;show(i);dialog.showModal();}));
  root.querySelector('.ba-mask-close').addEventListener('click',()=>dialog.close());
  root.querySelector('.ba-mask-prev').addEventListener('click',()=>show(selected-1));
  root.querySelector('.ba-mask-next').addEventListener('click',()=>show(selected+1));
  dialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();show(selected-1);}if(event.key==='ArrowRight'){event.preventDefault();show(selected+1);}});
  dialog.addEventListener('close',()=>{if(returnFocus)returnFocus.focus({preventScroll:true});});
 }
 init();
 document.addEventListener('DOMContentLoaded',init);
 document.addEventListener('shopify:section:load',init);
 new MutationObserver(init).observe(document.documentElement,{childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

})();
